const hy = {
  title: 'Page not found',
};

export default hy;
